import React                      from 'react';
import Tooltip                    from '@widesk-ui/components/Tooltip';
import { QuestionCircleOutlined } from '@ant-design/icons';
import useDesignTokens            from '@/hooks/useDesignTokens';

const HelpTip = ({ children }: { children: React.ReactNode; }) => {
	const tokens = useDesignTokens();

	return (
		<Tooltip title={children}>
			<QuestionCircleOutlined style={{ marginLeft: 6, color: tokens.text.muted, cursor: 'help' }} />
		</Tooltip>
	);
};

export default HelpTip;
